/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const Pagination = ({
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  pages,
}) => {
  return (
    <>
      <nav className="mt-4">
        <ul className="d-flex align-items-center gap-3 gap-md-5 justify-content-center">
          <li className={`px-5 py-3 br1 rounded-5 d-center ${currentPage === 1 ? "active" : ""}`}>
            <a
              href="#"
              className="p1-color fs-five"

              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1 ? true : false}
            ><span className="btn-border" />
              {"<<"}
            </a>
          </li>
          {currentPage - 2 > 0 ? (
            <li className="px-5 py-3 br1 rounded-5 d-center">
              <a
                href="#"
                className="p1-color fs-five"

                onClick={() => setCurrentPage((prev) => prev - 2)}
              ><span className="btn-border" />
                {currentPage - 2}
              </a>
            </li>
          ) : (
            ""
          )}
          {currentPage - 1 > 0 ? (
            <li className="px-5 py-3 br1 rounded-5 d-center">
              <a
                href="#"
                className="p1-color fs-five"

                onClick={() => setCurrentPage((prev) => prev - 1)}
              ><span className="btn-border" />
                {currentPage - 1}
              </a>
            </li>
          ) : (
            ""
          )}
          <li className="px-5 py-3 br1 rounded-5 d-center active">
            <a href="#"
            className="p1-color fs-five" disabled={true}>
              <span className="btn-border" />
              {currentPage}
            </a>
          </li>
          {currentPage + 1 <= pages ? (
            <li className="px-5 py-3 br1 rounded-5 d-center">
              <a
                href="#"
                className="p1-color fs-five"

                onClick={() => setCurrentPage((prev) => prev + 1)}
              >
                <span className="btn-border" />
                {currentPage + 1}
              </a>
            </li>
          ) : (
            ""
          )}
          {currentPage + 2 <= pages ? (
            <li className="px-5 py-3 br1 rounded-5 d-center">
              <a
                href="#"
                className="p1-color fs-five"

                onClick={() => setCurrentPage((prev) => prev + 2)}
              >
                <span className="btn-border" />
                {currentPage + 2}
              </a>
            </li>
          ) : (
            ""
          )}
          <li
            className={`px-5 py-3 br1 rounded-5 d-center ${currentPage === pages ? "active" : ""}`}
          >
            <a
              href="#"
              className="p1-color fs-five"
              onClick={() => setCurrentPage(pages)}
              disabled={currentPage === pages ? true : false}
            >
              <span className="btn-border" />
              {">>"}
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Pagination;
